/* ==========================================================================
   IMP — shared interactions
   ========================================================================== */
(function () {

  /* Horizontal swipe on an element; calls back with -1 (right) or 1 (left). */
  function addSwipe(el, onSwipe) {
    var x0 = null, y0 = null;
    el.addEventListener("touchstart", function (e) {
      var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY;
    }, { passive: true });
    el.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      // ignore mostly-vertical drags so page scrolling still works
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) onSwipe(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  "use strict";

  /* ---------- Mobile navigation ---------- */
  var toggle = document.querySelector(".nav-toggle");
  var nav = document.querySelector(".mainnav");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    // Close menu when a link is tapped
    nav.addEventListener("click", function (e) {
      if (e.target.tagName === "A") {
        nav.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ---------- Shop filter ---------- */
  var filterBtns = document.querySelectorAll(".filter-btn");
  var products = document.querySelectorAll(".product-grid .product");
  var emptyNote = document.querySelector(".empty-note");
  if (filterBtns.length && products.length) {
    filterBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var cat = btn.getAttribute("data-filter");
        filterBtns.forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        var shown = 0;
        products.forEach(function (p) {
          var match = cat === "all" || p.getAttribute("data-category") === cat;
          p.style.display = match ? "" : "none";
          if (match) shown++;
        });
        if (emptyNote) emptyNote.style.display = shown ? "none" : "";
      });
    });
  }

  /* ---------- Product detail: gallery, swipe, lightbox, sticky buy bar ---------- */
  var track = document.getElementById("pd-track");
  var pdSlides = track ? [].slice.call(track.querySelectorAll(".pd-slide")) : [];
  var thumbs = [].slice.call(document.querySelectorAll(".pd-thumbs .pd-thumb, .pd-thumbs .ph"));
  var pdDotsWrap = document.querySelector(".pd-dots");

  if (pdSlides.length) {
    var touchMQ = window.matchMedia("(max-width: 820px)");
    var isTouch = function () { return touchMQ.matches; };
    var pdIndex = 0;

    /* A dot per photo reads well up to a point; past that it becomes a smear of
       targets nobody can hit, so long galleries get a plain counter instead. */
    var pdDots = [], pdCounter = null, DOT_LIMIT = 8;
    if (pdDotsWrap) {
      if (pdSlides.length > DOT_LIMIT) {
        pdDotsWrap.classList.add("pd-dots--counter");
        pdCounter = document.createElement("span");
        pdCounter.setAttribute("aria-live", "polite");
        pdCounter.textContent = "1 / " + pdSlides.length;
        pdDotsWrap.appendChild(pdCounter);
      } else {
        pdSlides.forEach(function (_, i) {
          var d = document.createElement("button");
          d.type = "button";
          d.setAttribute("role", "tab");
          d.setAttribute("aria-label", "Photo " + (i + 1));
          if (i === 0) d.className = "is-active";
          d.addEventListener("click", function () { pdGo(i); });
          pdDotsWrap.appendChild(d);
          pdDots.push(d);
        });
      }
    }

    var pdMark = function (i) {
      pdIndex = i;
      pdSlides.forEach(function (s, n) { s.classList.toggle("is-active", n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle("is-active", n === i); });
      pdDots.forEach(function (d, n) { d.classList.toggle("is-active", n === i); });
      if (pdCounter) pdCounter.textContent = (i + 1) + " / " + pdSlides.length;
      if (lbImg && pdSlides[i]) { lbImg.src = pdSlides[i].src; lbImg.alt = pdSlides[i].alt; }
    };

    /* On touch widths the track scrolls; on desktop we just swap the visible slide. */
    // While we scroll the track ourselves, ignore the scroll handler: mid-flight
    // it would compute the old slide as "nearest" and undo the jump.
    var seeking = null;
    var pdGo = function (i, smooth) {
      i = (i + pdSlides.length) % pdSlides.length;
      if (isTouch()) {
        clearTimeout(seeking);
        seeking = setTimeout(function () { seeking = null; }, 700);
        track.scrollTo({ left: pdSlides[i].offsetLeft - track.offsetLeft,
                         behavior: smooth === false ? "auto" : "smooth" });
      }
      pdMark(i);
    };
    var pdStep = function (dir) { pdGo(pdIndex + dir); };

    thumbs.forEach(function (t, i) {
      t.addEventListener("click", function () { pdGo(i); });
    });

    /* Swiping the track updates thumbs and pdDots */
    var scrollTimer = null;
    track.addEventListener("scroll", function () {
      if (!isTouch() || seeking) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var nearest = 0, best = Infinity;
        pdSlides.forEach(function (s, i) {
          var c = s.offsetLeft - track.offsetLeft + s.clientWidth / 2;
          var d = Math.abs(c - mid);
          if (d < best) { best = d; nearest = i; }
        });
        if (nearest !== pdIndex) pdMark(nearest);
      }, 90);
    }, { passive: true });

    /* Keep the right photo in view when switching between layouts */
    touchMQ.addEventListener("change", function () { pdGo(pdIndex, false); });

    /* ---- Fullscreen lightbox (desktop click, mobile long-press free) ---- */
    var lb = null, lbImg = null;
    lb = document.createElement("div");
    lb.className = "lightbox";
    lb.innerHTML =
      '<button class="lightbox__close" type="button" aria-label="Close">&times;</button>' +
      '<button class="lightbox__nav lightbox__nav--prev" type="button" aria-label="Previous">&#8249;</button>' +
      '<img alt="">' +
      '<button class="lightbox__nav lightbox__nav--next" type="button" aria-label="Next">&#8250;</button>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector("img");
    lbImg.src = pdSlides[0].src;
    lbImg.alt = pdSlides[0].alt;

    var openLb = function () { lb.classList.add("is-open"); document.body.classList.add("lb-open"); };
    var closeLb = function () { lb.classList.remove("is-open"); document.body.classList.remove("lb-open"); };
    var lbIsOpen = function () { return lb.classList.contains("is-open"); };

    pdSlides.forEach(function (s) {
      s.addEventListener("click", function () { if (!isTouch()) openLb(); });
    });
    lb.querySelector(".lightbox__close").addEventListener("click", closeLb);
    lb.querySelector(".lightbox__nav--prev").addEventListener("click", function (e) { e.stopPropagation(); pdStep(-1); });
    lb.querySelector(".lightbox__nav--next").addEventListener("click", function (e) { e.stopPropagation(); pdStep(1); });
    lb.addEventListener("click", function (e) { if (e.target === lb) closeLb(); });
    addSwipe(lb, function (dir) { pdStep(dir); });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { closeLb(); return; }
      if (e.key === "ArrowLeft") { pdStep(-1); }
      else if (e.key === "ArrowRight") { pdStep(1); }
      else return;
      if (lbIsOpen()) e.preventDefault();
    });
  }

  /* ---------- Sticky buy bar on narrow screens ---------- */
  var bar = document.querySelector("[data-pd-bar]");
  var anchor = document.querySelector(".pd-actions");
  if (bar && anchor) {
    bar.hidden = false;
    document.body.classList.add("has-pd-bar");

    // Show it only once the real buttons are off-screen and the page has actually
    // been scrolled — an IntersectionObserver alone also fires while they are
    // still below the fold, which would pin the bar there from the first paint.
    var ticking = false;
    var syncBar = function () {
      var r = anchor.getBoundingClientRect();
      var onScreen = r.top < window.innerHeight && r.bottom > 0;
      bar.classList.toggle("is-in", !onScreen && window.scrollY > 260);
      ticking = false;
    };
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(syncBar); }
    }, { passive: true });
    window.addEventListener("resize", syncBar, { passive: true });
    syncBar();

    var barAdd = bar.querySelector("[data-bar-add]");
    if (barAdd) {
      barAdd.addEventListener("click", function () {
        var realBtn = document.querySelector("#pd-form [name='add']");
        if (realBtn) realBtn.click();
      });
    }
    // keep the bar price in step with the variant picker
    document.addEventListener("imp:variant", function (e) {
      var out = bar.querySelector("[data-bar-price]");
      if (out && e.detail && e.detail.price) out.textContent = e.detail.price;
    });
  }


  /* ---------- Audience tabs (Bespoke: individuals vs business) ---------- */
  var tabsRoot = document.querySelector("[data-audience-tabs]");
  if (tabsRoot) {
    // Sections in a JSON template render as shopify-section-template--<id>__<key>,
    // so match on the key suffix rather than a guessed exact id.
    var findPane = function (name) {
      var key = name.replace(/^shopify-section-/, "");
      return document.getElementById(name) ||
             document.querySelector('[id$="__' + key + '"]');
    };
    var paneA = findPane(tabsRoot.getAttribute("data-pane-a"));
    var paneB = findPane(tabsRoot.getAttribute("data-pane-b"));
    var tabBtns = [].slice.call(tabsRoot.querySelectorAll(".tab"));

    if (paneA && paneB) {
      var showTab = function (which, push) {
        paneA.classList.toggle("pane-hidden", which !== "a");
        paneB.classList.toggle("pane-hidden", which !== "b");
        tabBtns.forEach(function (b) {
          var on = b.getAttribute("data-tab") === which;
          b.classList.toggle("is-active", on);
          b.setAttribute("aria-selected", on ? "true" : "false");
        });
        if (push && history.replaceState) {
          history.replaceState(null, "", which === "b" ? "#business" : location.pathname);
        }
      };

      tabBtns.forEach(function (b) {
        b.addEventListener("click", function () { showTab(b.getAttribute("data-tab"), true); });
      });

      // deep links: /pages/bespoke#business (and #b2b, kept for older links)
      var hash = (location.hash || "").toLowerCase();
      showTab(hash === "#business" || hash === "#b2b" ? "b" : "a", false);
      window.addEventListener("hashchange", function () {
        var h = (location.hash || "").toLowerCase();
        showTab(h === "#business" || h === "#b2b" ? "b" : "a", false);
      });
    }
  }

  /* ---------- Form handling (client-side demo) ---------- */
  function wireForm(form) {
    if (!form) return;
    var note = form.querySelector(".form-note");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      // Basic native validation check
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (note) {
        note.textContent = form.getAttribute("data-success") ||
          "Thank you — we’ve received your message and will reply within two business days.";
        note.classList.remove("err");
        note.classList.add("ok");
      }
      form.reset();
      setTimeout(function () { if (note) { note.textContent = ""; note.classList.remove("ok"); } }, 8000);
    });
  }
  document.querySelectorAll("form[data-jsform]").forEach(wireForm);

  /* ---------- Footer year ---------- */
  var yearEl = document.getElementById("year");
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  /* ---------- Hero slideshow ---------- */
  var hero = document.querySelector("[data-hero]");
  if (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll(".hero-slide"));
    var dotsWrap = hero.querySelector(".hero-dots");
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var idx = 0, timer = null, dots = [];

    if (dotsWrap && slides.length > 1) {
      slides.forEach(function (_, n) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "hero-dot" + (n === 0 ? " is-active" : "");
        b.setAttribute("aria-label", "Go to slide " + (n + 1));
        b.addEventListener("click", function () { go(n); restart(); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function go(n) {
      slides[idx].classList.remove("is-active");
      if (dots[idx]) dots[idx].classList.remove("is-active");
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add("is-active");
      if (dots[idx]) dots[idx].classList.add("is-active");
    }
    function start() { if (!reduce && slides.length > 1) timer = setInterval(function () { go(idx + 1); }, 5500); }
    function restart() { clearInterval(timer); start(); }

    if (slides.length > 1) {
      start();
      addSwipe(hero, function (dir) { go(idx + dir); restart(); });
      // Keyboard arrows switch slides
      document.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") { go(idx - 1); restart(); }
        else if (e.key === "ArrowRight") { go(idx + 1); restart(); }
      });
    }
  }
})();

/* ==========================================================================
   IMP — Shopify storefront (cart drawer, add-to-cart, variants)
   ========================================================================== */
(function () {
  "use strict";
  var money = function (c) {
    return (c / 100).toLocaleString(undefined, { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR" });
  };

  var drawer = document.getElementById("cart-drawer");
  var drawerBody = document.querySelector("[data-cart-body]");
  var countEls = document.querySelectorAll("[data-cart-count]");
  function openDrawer() { if (drawer) { drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true"); } }
  document.querySelectorAll("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });

  function renderCart(cart) {
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (!drawerBody) return;
    if (!cart.items.length) { drawerBody.innerHTML = '<p class="lede">Your bag is empty.</p>'; return; }
    var html = "";
    cart.items.forEach(function (it) {
      html += '<div class="cart-item"><a href="' + it.url + '" class="cart-item__img">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="cart-item__info"><a href="' + it.url + '"><h3>' + it.product_title + '</h3></a>' +
        (it.variant_title ? '<p class="cat">' + it.variant_title + '</p>' : '') +
        '<p class="price">' + money(it.final_price) + ' × ' + it.quantity + '</p></div></div>';
    });
    html += '<div class="cart-foot"><div class="cart-subtotal"><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
      '<a class="btn btn--solid btn--block" href="/checkout">Checkout</a>' +
      '<a class="btn btn--block" href="/cart" style="margin-top:.6rem">View bag</a></div>';
    drawerBody.innerHTML = html;
  }
  function refreshCart() {
    fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  var pdForm = document.getElementById("pd-form");
  if (pdForm) {
    var variantSelect = pdForm.querySelector("#variant-id");
    var optionSelects = pdForm.querySelectorAll("[data-variant-option]");
    var priceEl = document.getElementById("pd-price");
    if (variantSelect && optionSelects.length) {
      var sync = function () {
        var chosen = Array.prototype.map.call(optionSelects, function (s) { return s.value; }).join(" / ");
        Array.prototype.forEach.call(variantSelect.options, function (opt) {
          if (opt.text.trim() === chosen) {
            variantSelect.value = opt.value;
            var p = opt.getAttribute("data-price");
            if (priceEl && p) priceEl.textContent = p;
            // the sticky mobile bar shows the same price
            if (p) document.dispatchEvent(new CustomEvent("imp:variant", { detail: { price: p } }));
          }
        });
      };
      optionSelects.forEach(function (s) { s.addEventListener("change", sync); });
    }
    pdForm.addEventListener("submit", function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = pdForm.querySelector("[name='add']");
      if (btn) { btn.dataset.label = btn.textContent; btn.disabled = true; btn.textContent = "Adding…"; }
      fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: variantSelect ? variantSelect.value : null, quantity: 1 })
      }).then(function (r) { return r.json(); })
        .then(function () { refreshCart(); openDrawer(); })
        .catch(function () { pdForm.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || "Order this piece"; } });
    });
  }

  document.querySelectorAll("[data-cart-open]").forEach(function (a) {
    a.addEventListener("click", function (e) { if (drawer && window.fetch) { e.preventDefault(); refreshCart(); openDrawer(); } });
  });
})();
